"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validationHelpers_1 = require("./validationHelpers");
// Executes client-specific validation rules if provided by the strategy.
const executeClientValidation = (strategy, validationInput) => {
    var _a, _b;
    return (_b = (_a = strategy.validateProNumber) === null || _a === void 0 ? void 0 : _a.call(strategy, validationInput)) !== null && _b !== void 0 ? _b : null;
};
const runValidations = (validators) => {
    for (const validator of validators) {
        const error = validator();
        if (error)
            return error;
    }
    return null;
};
const createProNumberValidator = (strategy) => (validationInput) => {
    var _a;
    const { proNumber, completedProList, shipmentId } = validationInput;
    // Trim pro number before validation (safe trim - handles undefined/null)
    const trimmedPro = (_a = proNumber === null || proNumber === void 0 ? void 0 : proNumber.trim()) !== null && _a !== void 0 ? _a : null;
    // Run all validations in sequence
    return runValidations([
        // Step 1: Check if pro number is provided
        () => (0, validationHelpers_1.checkIfProNumberIsProvided)(trimmedPro),
        // Step 2: Validate format (numeric digits only)
        () => (0, validationHelpers_1.validateProNumberFormat)(trimmedPro),
        // Step 3: Check for duplicates
        () => (0, validationHelpers_1.checkForDuplicate)(completedProList || [], trimmedPro, shipmentId || null),
        // Step 4: Execute client-specific validations
        () => executeClientValidation(strategy, {
            ...validationInput,
            proNumber: trimmedPro,
        }),
    ]);
};
exports.default = createProNumberValidator;
